<div
    class="retrieve-quote"
    role="presentation"
>
    <section class="retrieve-quote__content">
        <qe-content-section>
            <epi-heading
                level="1"
                color="primary"
                class="u-margin-bottom-small"
            >
                Welcome Back! Retrieve Your Previous Quote
            </epi-heading>
            <form
                [formGroup]="quoteRetrievalForm"
                class="retrieve-quote__form"
            >
                <div
                    class="u-row u-margin-top-small"
                    role="presentation"
                >
                    <div class="c-form-input u-row__column m--tablet-6">
                        <epi-input
                            [invalid]="emailAddress?.invalid && emailAddress?.dirty"
                            input-id="emailAddress"
                        >
                            <span slot="label">Email</span>
                            <input
                                formControlName="emailAddress"
                                type="text"
                                inputmode="email"
                                slot="epiInput"
                                data-quat="input_emailAddress"
                            >
                            <epi-validation-error
                                *ngIf="emailAddress?.errors?.required && (emailAddress?.touched || formInvalid)"
                                data-quat="alert_emailAddressValidation"
                            >Please enter your email address.</epi-validation-error>
                            <epi-validation-error
                                *ngIf="emailAddress?.errors?.email && (emailAddress?.touched || formInvalid)"
                                data-quat="alert_emailAddressValidation"
                            >Please enter a valid email address.</epi-validation-error>
                        </epi-input>
                    </div>
                </div>
                <div
                    class="u-row u-margin-top-small"
                    role="presentation"
                >
                    <div class="c-form-input u-row__column m--tablet-6">
                        <epi-input
                            [invalid]="zipCode?.invalid && zipCode?.dirty"
                            input-id="zipCode"
                        >
                            <span slot="label">Zip Code</span>
                            <input
                                formControlName="zipCode"
                                slot="epiInput"
                                type="text"
                                inputmode="numeric"
                                minlength="5"
                                maxlength="5"
                                data-quat="input_zipCode"
                            >
                            <epi-validation-error
                                *ngIf="zipCode?.errors?.required && (zipCode?.touched || formInvalid)"
                                data-quat="alert_zipCodeValidation"
                            >
                                Please enter your zip code of residence.
                            </epi-validation-error>
                        </epi-input>
                        <epi-validation-error *ngIf="zipCode?.errors?.pattern && (zipCode?.touched || formInvalid)">
                            Zip code may only contain digits.
                        </epi-validation-error>
                        <epi-validation-error
                            *ngIf="(zipCode?.errors?.minlength || zipCode?.errors?.maxlength) && (zipCode?.touched || formInvalid)"
                        >
                            Zip code must be 5 digits long.
                        </epi-validation-error>
                    </div>
                </div>

                <div
                    class="u-row u-margin-top-medium"
                    role="presentation"
                >
                    <div
                        class="u-row__column"
                        role="presentation"
                    >
                        <epi-validation-error
                            *ngIf="formInvalid"
                            class="u-margin-bottom-small"
                        >
                            Please complete all required fields before continuing.
                        </epi-validation-error>
                        <div role="presentation">
                            <button
                                type="submit"
                                qeBaseButton
                                (click)="submitForm()"
                                data-quat="action_startQuote"
                            >Retrieve Quote</button>
                        </div>
                    </div>
                </div>
            </form>
        </qe-content-section>
    </section>
    <section class="retrieve-quote__sidebar">
        <qe-sidebar-infocard>
            <epi-heading
                level="3"
                class="m--no-margin u-align-items-center m--color-white"
            >
                <epi-icon
                    use="clock"
                    size="20"
                    color="custom:#ffffff"
                    class="retrieve-quote__sidebar-heading-icon"
                ></epi-icon>
                After You Enroll
            </epi-heading>
            <div
                role="presentation"
                class="retrieve-quote__sidebar-card-content"
            >
                <epi-list
                    class="retrieve-quote__sidebar-card-list"
                    marker-color="primary"
                >
                    <epi-list-item *ngFor="let item of afterYouEnroll">{{ item }}</epi-list-item>
                </epi-list>
            </div>
        </qe-sidebar-infocard>
        <qe-sidebar-infocard
            headingBackground="secondary"
            class="u-margin-top-small"
        >
            <epi-heading
                level="3"
                class="m--no-margin u-align-items-center m--color-white"
            >
                <epi-icon
                    use="outlined-check"
                    color="custom:#ffffff"
                    size="20"
                    class="retrieve-quote__sidebar-heading-icon"
                ></epi-icon>
                Why Embrace?
            </epi-heading>
            <div
                role="presentation"
                class="retrieve-quote__sidebar-card-content"
            >
                <epi-list
                    class="retrieve-quote__sidebar-card-list"
                    marker-color="primary"
                >
                    <epi-list-item heading="Simple Claims Processing">
                        Submitting claims is a breeze and you can track it from submission to completion with MyEmbrace
                        online or in
                        the mobile app.
                    </epi-list-item>
                    <epi-list-item heading="Customer Service You Can Count On">
                        Our Customer Care team is available by phone and email to offer genuine support and answers when
                        you need
                        them most.
                    </epi-list-item>
                    <epi-list-item heading="Online Policy Management">
                        Manage your policy on the go anytime, anywhere with MyEmbrace online or in the Embrace Pet
                        Insurance app for
                        Android and iOS.
                    </epi-list-item>
                </epi-list>
            </div>
        </qe-sidebar-infocard>
    </section>
</div>
